import React from "react";
import aboutImage from "../../../assets/aboutImage.png";

const About = () => {
  return (
    <div className="font-poppins flex flex-col sm:flex-row w-full bg-neutral-grey mt-[30px] md:mt-[80px] md:mb-32">

      {/* Left Image */}
      <div className="w-full sm:w-[50vw] max-w-[820px]">
        <img
          src={aboutImage}
          alt="About Boo"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Right Text */}
      <div className="w-full sm:w-[50vw] text-white px-[6%] py-[12%]">

        <div className="font-medium text-[24px] sm:text-[32px] uppercase leading-[38px] sm:leading-[53px]">
          ABOUT BOO
        </div>

        <div className="font-normal text-[14px] sm:text-[16px] leading-[28px] sm:leading-[32px] text-neutral-halfwhite mt-4">
          We design premium, gender-neutral essentials that move <br className="hidden sm:block" />
          with you — thoughtfully crafted for self-expression and <br className="hidden sm:block" />
          everyday comfort. We design premium, gender-neutral <br className="hidden sm:block" />
          essentials that move with you — thoughtfully crafted for <br className="hidden sm:block" />
          self-expression and everyday comfort. We design premium, <br className="hidden sm:block" />
          gender-neutral essentials that move with you — thoughtfully <br className="hidden sm:block" />
          crafted for self-expression and everyday comfort.
        </div>
      </div>
    </div>
  );
};

export default About;
